$(document).ready(function () {

    // Show/hide more endorsement categories
    $('#see-more-endorsements').click(function () {
        $('#additional-endorsements-container').slideToggle(400, function () {
            $('#see-more').toggle();
            $('#see-less').toggle();
        });
    });

    // Add endorsement
    $('.btn-endorse-user').click(function () {

        // Setup vars for cleaner code and faster execution
        var $this = $(this);
        var endorseTypeId = $this.data('endorsement-type-id');
        var $endorseObj = $('#jvzEndorseTypeObj' + endorseTypeId);
        var isEndorsed = $this.data('is-endorsed');
        var setEndorse = !isEndorsed;
        var $btnEndorseUser = $('#btnEndorseUser' + endorseTypeId);
        var $btnUnendorseUser = $('#btnUnendorseUser' + endorseTypeId);
        var $endorsingSpinner = $('#endorsingSpinner' + endorseTypeId);
        var $endorserLabelNone = $('#jvzEndorserLabelNone' + endorseTypeId);
        var $endorserLabelOne = $('#jvzEndorserLabelOne' + endorseTypeId);
        var $endorserLabelMany = $('#jvzEndorserLabelMany' + endorseTypeId);
        var $endorserLabelEndorseRecorded = $('#jvzEndorserLabelEndorseRecorded' + endorseTypeId);
        var $endorserLabelUendorseRecorded = $('#jvzEndorserLabelUnendorseRecorded' + endorseTypeId);
        var $endorserLabelErrorRecorded = $('#jvzEndorserLabelErrorRecorded' + endorseTypeId);
        var $endorseTagCount = $('#jvzTagEndorsementCount' + endorseTypeId);
        var curCount = parseInt($endorseTagCount.text());

        $btnEndorseUser.hide();
        $btnUnendorseUser.hide();
        $endorsingSpinner.show();

        // Post parameters so we can add the csrf key name dynamically
        var postParams = {type_id: endorseTypeId, endorsed_id: $endorseObj.data('endorsed-user-id'), endorsing_id: $endorseObj.data('endorsing-user-id'), is_endorsed: Number(setEndorse)};
        postParams[$endorseObj.data('csrf-name')] = $endorseObj.data('csrf-hash');

        // Post endorse
        $.post('/user/endorse/update', postParams, function () {

            // Post succeeded

            if (setEndorse) {
                // Endorse

                // Show Endorsed button
                $btnUnendorseUser.show();
                $endorsingSpinner.hide();

                // Update tag count
                $endorseTagCount.text(curCount + 1);

                // Update label
                $endorserLabelUendorseRecorded.hide();
                $endorserLabelErrorRecorded.hide();
                $endorserLabelEndorseRecorded.show();
            } else {
                // Unendorse

                // Show Endorse button
                $btnEndorseUser.show();
                $endorsingSpinner.hide();

                // Update tag count
                $endorseTagCount.text(curCount - 1);

                // Update label
                $endorserLabelEndorseRecorded.hide();
                $endorserLabelErrorRecorded.hide();
                $endorserLabelUendorseRecorded.show();
            }

            // Hide Labels
            $endorserLabelNone.hide();
            $endorserLabelOne.hide();
            $endorserLabelMany.hide();


        }).fail(function () {
            // Post failed

            // Return button to previous state
            if (setEndorse) {
                $btnEndorseUser.show();
                $btnUnendorseUser.hide();
                $endorsingSpinner.hide();
            } else {
                $btnEndorseUser.hide();
                $btnUnendorseUser.show();
                $endorsingSpinner.hide();
            }

            // Update label
            $endorserLabelEndorseRecorded.hide();
            $endorserLabelUendorseRecorded.hide();
            $endorserLabelNone.hide();
            $endorserLabelOne.hide();
            $endorserLabelMany.hide();
            $endorserLabelErrorRecorded.show();
        });
    });

    // High Performance tooltips
    $('#jvz-badge-high-performance').tooltip({
        html: true,
        placement: 'right'
    })
});